import { JwtPayload } from 'jwt-decode';
import { AuthPermission } from 'skipify-types';
import { auth0Config } from '../services/auth0';

/**
 * Decoded JWT payload extended from original JwtPayload
 * to include Auth0 permissions
 */
export interface DecodedJwtPayload extends JwtPayload {
  email: string;
  permissions?: AuthPermission[];
}
/**
 * Wrapper around Auth0's getAccessTokenSilently that includes the required audience and scope
 */
export const getAccessTokenWithAudience = async (
  getAccessTokenSilently: (options?: any) => Promise<string>,
  options: any = {},
): Promise<string> => {
  return getAccessTokenSilently({
    authorizationParams: {
      audience: auth0Config.authorizationParams.audience,
      scope: auth0Config.authorizationParams.scope,
    },
    ...options,
  });
};
